import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './responsive-video-list.scss';
import Slider from '../../../components/slider/slider';
import { VIDEO_LIST_ITEM_WIDTH } from '../../../constants/lightbox';
import {
  isThumbnailsPreviewHover,
  isExpandedModeVideosListInfoAlwaysShown,
  isExpandedModeVideosListInfoShownOnHover,
} from '../../../selectors/app-settings';
import { getVideosGroupedByIds } from '../../../selectors/videos';
import VideoThumbnailOverlay from '../../../components/video-thumbnail-overlay/video-thumbnail-overlay';
import InFrameActionCallbacks from '../../../layouts/compact/actions/overlay-action-callbacks/in-frame';
import ContainerSize from '../../containers/container-size';
import { loadMore } from '../../../redux/lazy-channel-videos/actions';
import {
  getIsFetching,
  getCursor,
  getVideoIds,
} from '../../../redux/lazy-channel-videos/selectors';
import ItemLoading from '@wix/wix-vod-shared/dist/esm/widget/ui-components/slider/item-loading/item-loading';

const mapStateToProps = (state) => ({
  videoIds: getVideoIds(state),
  videoByIds: getVideosGroupedByIds(state),
  isThumbnailsPreviewHover: isThumbnailsPreviewHover(state),
  isInfoAlwaysShown: isExpandedModeVideosListInfoAlwaysShown(state),
  isInfoShownOnHover: isExpandedModeVideosListInfoShownOnHover(state),
  isFetching: getIsFetching(state),
  nextVideosCursor: getCursor(state),
});

const mapDispatchToProps = {
  loadMore,
};

const ResponsiveVideoList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class ResponsiveVideoList extends React.Component {
    static propTypes = {
      isThumbnailsPreviewHover: PropTypes.bool.isRequired,
      isInfoAlwaysShown: PropTypes.bool.isRequired,
      isInfoShownOnHover: PropTypes.bool.isRequired,
      isFetching: PropTypes.bool.isRequired,
      isRTL: PropTypes.bool.isRequired,
      nextVideosCursor: PropTypes.string,
      mainVideo: PropTypes.object.isRequired,
      videoIds: PropTypes.arrayOf(PropTypes.string).isRequired,
      videoByIds: PropTypes.object.isRequired,
      currentSiteUser: PropTypes.object,
      channel: PropTypes.object,
      onPlayRequestedBi: PropTypes.func.isRequired,
      loadMore: PropTypes.func.isRequired,
      onItemClick: PropTypes.func,
      subscribeOnParentScroll: PropTypes.func,
      unSubscribeFromParentScroll: PropTypes.func,
    };

    loadMore = (itemsToLoadCount) => {
      const { nextVideosCursor, isFetching } = this.props;

      if (nextVideosCursor && !isFetching) {
        this.props.loadMore(itemsToLoadCount);
      }
    };

    renderItem = (width, height, videoId) => {
      const {
        currentSiteUser,
        channel,
        mainVideo,
        isRTL,
        isInfoAlwaysShown,
        isInfoShownOnHover,
        onPlayRequestedBi,
        onItemClick,
        videoByIds,
      } = this.props;

      if (!width || !height) {
        return null;
      }

      if (!videoId) {
        return (
          <div
            style={{
              width,
              height,
            }}
          >
            <ItemLoading active />
          </div>
        );
      }

      const video = videoByIds[videoId];
      const { id, videoSource } = video;
      const isSelected = mainVideo && mainVideo.id === id;
      const onClick = _.partial(onItemClick, videoId);

      return (
        <InFrameActionCallbacks
          channelId={channel.id}
          videoId={id}
          videoSource={videoSource}
          onPlayRequestedBi={_.partial(onPlayRequestedBi, video)}
          key={id}
          onBeforeClick={onClick}
          onBeforePlayRequested={onClick}
        >
          <VideoThumbnailOverlay
            currentSiteUser={currentSiteUser}
            channelData={channel}
            videoItem={video}
            isSelected={isSelected}
            isThumbnailsPreviewHover={this.props.isThumbnailsPreviewHover}
            isInfoAlwaysShown={isInfoAlwaysShown}
            isInfoShownOnHover={isInfoShownOnHover}
            width={width}
            height={height}
            isRTL={isRTL}
          />
        </InFrameActionCallbacks>
      );
    };

    render() {
      const {
        channel,
        videoIds,
        subscribeOnParentScroll,
        unSubscribeFromParentScroll,
      } = this.props;

      return (
        <ContainerSize className={styles.sliderContainer}>
          {({ width }) => {
            const isVertical = width <= 768;
            const itemWidth = isVertical ? width : VIDEO_LIST_ITEM_WIDTH;
            const itemHeight = (itemWidth / 16) * 9;

            return (
              <Slider
                items={videoIds}
                itemsCount={channel.videosCount}
                loadMore={this.loadMore}
                renderItem={_.partial(this.renderItem, itemWidth, itemHeight)}
                vertical={isVertical}
                subscribeOnParentScroll={subscribeOnParentScroll}
                unSubscribeFromParentScroll={unSubscribeFromParentScroll}
              />
            );
          }}
        </ContainerSize>
      );
    }
  },
);

export default ResponsiveVideoList;
